export default __webpack_public_path__ + "static/media/Main.f648c43f.png";